//#region Angular Imports

import { StateService, StateProvider } from '@uirouter/angularjs'
import * as angular from 'angular'
import 'angular-gridster'

//#endregion


// #region Imports

import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { default as commonModule } from './../common/common.module'

import { Api, default as apiModule, LocalDictionaryFactory } from './../api/api.module'

import { Activity, Enums } from '../../models/common'
import { OpOperator } from '../../models/core'

import { ConfigHelper, UserSession } from '../../helpers'
import { GridService, GridContextMenuService, GRID_SERVICE_NAME, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'
import { LocationService, LOCATION_SERVICE_NAME, LocationRelatedObjectService, LOCATION_RELATED_OBJECT_SERVICE_NAME } from '../../services/location'
import { $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $STATE_SERVICE_PROVIDER_NAME, $TIMEOUT_SERVICE_NAME, PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'
import { UserSessionService, USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { LocationsMassGroupsEditErrorsSummaryService, LocationsMassGroupsEditService, LOCATIONS_MASS_GROUPS_EDIT_ERRORS_SUMMARY_SERVICE_NAME, LOCATIONS_MASS_GROUPS_EDIT_SERVICE_NAME } from './services/locations-mass-groups-edit'


import { LocationsCreateEditDirective } from './create-edit/locations-create-edit.directive'
import { LocationsDetailsDirective } from './details/locations-details.directive'
import { KingspanCreateEditDirective, KingspanDeviceFormComponent } from './location-configuration-form-kingspan'
import { KingspanCreateEditPopupDirective } from './location-configuration-form-kingspan/kingspan-create-edit-popup/kingspan-create-edit-popup.directive'
import { COMPONENT_NAME as LOCATIONS_MASS_GROUP_EDIT_COMPONENT, LocationsMassGroupsEditComponent } from './locations-mass-groups-edit/locations-mass-groups-edit.component'
import { COMPONENT_NAME as LOCATIONS_MASS_SEND_CONFIGURATION_PROFILE_NAME, LocationsMassSendConfigurationProfileComponent } from './locations-mass-send-configuration-profile/locations-mass-send-configuration-profile.component'
import { LocationsController } from './locations.controller'

// #endregion

//#region Assets Imports

import './locations.scss'
import * as TEMPLATE from './locations.tpl.html'

//#endregion

// #region Consts

const CONTROLER_NAME: string = 'LocationsController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'locationCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'locationDetails'

const KINGSPAN_DEVICE_FORM_NAME: string = 'kingspanDeviceForm'
const KINGSPAN_CREATE_EDIT_NAME: string = 'kingspanCreateEdit'
const KINGSPAN_CREATE_EDIT_POPUP_NAME: string = 'kingspanCreateEditPopup'

const MODULE_NAME: string = 'simax.locations'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Locations'

const MENU_INDEX: number = 2

const STATE_NAME: string = 'locations'
const STATE_URL: string = '/locations'

// #endregion

// #region Setup

// #region Module

const module = angular.module(MODULE_NAME, [
    commonModule,
    apiModule,
    'gridster',
    SERVICES_MODULE_NAME
])

// #endregion

// #region Services

module.service(LOCATIONS_MASS_GROUPS_EDIT_SERVICE_NAME, [USER_SESSION_SERVICE_NAME, LocationsMassGroupsEditService])
module.service(LOCATIONS_MASS_GROUPS_EDIT_ERRORS_SUMMARY_SERVICE_NAME, [LocationsMassGroupsEditErrorsSummaryService])

// #endregion

// #region Controller

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'localDictionary',
    USER_SESSION_SERVICE_NAME,
    LOCATION_SERVICE_NAME,
    LOCATION_RELATED_OBJECT_SERVICE_NAME,
    GRID_SERVICE_NAME,
    GRID_CONTEXT_MENU_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope,
        $state: StateService,
        $timeout,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService,
        locationService: LocationService,
        locationRelatedObjectService: LocationRelatedObjectService,
        gridService: GridService,
        gridContextMenuService: GridContextMenuService,
        systemService: SystemService
    ) => new LocationsController(
        $scope,
        $state,
        $timeout,
        api,
        localDictionary,
        locationService,
        locationRelatedObjectService,
        gridService,
        gridContextMenuService,
        userSession,
        systemService,
        LocationService.SIMAX_MODULE_NAME,
        LocationService.REFERENCE_TYPE
    )
])

// #endregion

// #region Directive

module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new LocationsCreateEditDirective()])
module.directive(DETAILS_DIRECTIVE_NAME, [() => new LocationsDetailsDirective()])

module.directive(KINGSPAN_CREATE_EDIT_NAME, [() => new KingspanCreateEditDirective()])
module.directive(KINGSPAN_CREATE_EDIT_POPUP_NAME, [() => new KingspanCreateEditPopupDirective()])

// #endregion

// #region Component

module.component(LOCATIONS_MASS_SEND_CONFIGURATION_PROFILE_NAME, new LocationsMassSendConfigurationProfileComponent())
module.component(LOCATIONS_MASS_GROUP_EDIT_COMPONENT, new LocationsMassGroupsEditComponent())
module.component(KINGSPAN_DEVICE_FORM_NAME, new KingspanDeviceFormComponent())

// #endregion

// #region Module config

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Location_IdLocation',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider.getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.LOCATION_LIST)
                && !loggedOperator.hasPermission(Activity.LOCATION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.LocationModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.LOCATIONS),
                    'locations',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// #endregion

// #endregion

export default MODULE_NAME
